import React from "react";
import {useNavigate} from "react-router-dom";
import {Header, StyledCard, Subtext,} from "./EmailConfirmed.styled";
import {AuthContainer} from "../Auth.styled";
import {brand} from "../../../theme/brand";
import {usePageTitle} from "../../../hooks/usePageTitle";
import {PageTitleKeys} from "../../../config/routeConstants";
import {useTranslation} from 'react-i18next';
import LogoWithLanguageSwitcher from '../../../components/common/LogoWithLanguageSwitcher';
import {Button} from "@mui/material";

const EmailConfirmed = () => {
    usePageTitle(PageTitleKeys.EmailConfirmed);

    const {t} = useTranslation();
    const navigate = useNavigate();

    return (
        <AuthContainer role="region" aria-labelledby="email-confirmed-title">
            <LogoWithLanguageSwitcher src={brand.logo} alt={t('auth.logo.alt')} clickable={false} />

            <StyledCard>
                <Header id="email-confirmed-title">
                    {t('emailConfirmed.title')}
                </Header>

                <Subtext>
                    {t('emailConfirmed.subtitle')}
                </Subtext>

                <Button variant="contained" fullWidth onClick={() => navigate("/login")} aria-label={t('emailConfirmed.buttonText.ariaLabel') as string}>
                    {t('emailConfirmed.buttonText')}
                </Button>
            </StyledCard>
        </AuthContainer>
    );
};

export default EmailConfirmed;
